import { render, staticRenderFns } from "./salaryPaid.vue?vue&type=template&id=5f5f4ada&scoped=true"
import script from "./salaryPaid.vue?vue&type=script&lang=js"
export * from "./salaryPaid.vue?vue&type=script&lang=js"
import style0 from "./salaryPaid.vue?vue&type=style&index=0&id=5f5f4ada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5f4ada",
  null
  
)

export default component.exports